/**
 * CPT visit billing: duration tiers and optional single-unit CPT override
 * (is_single_billable_unit from GET /visit-bills/cpt-code-list).
 * Override applies only when a CPT is selected and that row has the flag === true.
 */

export const BILL_UNIT_TIERS = [
  {
    key: 0,
    value: "0 units - Not billable",
    start_time: 0,
    end_time: 7
  },
  {
    key: 1,
    value: "1 unit - 8-22 minutes",
    start_time: 8,
    end_time: 22
  },
  {
    key: 2,
    value: "2 units - 23-37 minutes",
    start_time: 23,
    end_time: 37
  },
  {
    key: 3,
    value: "3 units - 38-52 minutes",
    start_time: 38,
    end_time: 52
  },
  {
    key: 4,
    value: "4 units - 53-67 minutes",
    start_time: 53,
    end_time: 67
  },
  {
    key: 5,
    value: "5 units - 68-82 minutes",
    start_time: 68,
    end_time: 82
  },
  {
    key: 6,
    value: "6 units - 83-97 minutes",
    start_time: 83,
    end_time: 97
  },
  {
    key: 7,
    value: "7 units - 98-112 minutes",
    start_time: 98,
    end_time: 112
  },
  {
    key: 8,
    value: "8 units - 113-127 minutes",
    start_time: 113,
    end_time: 127
  }
];

const singleUnitTier = () => {
  const one = BILL_UNIT_TIERS.find(u => u.key === 1);
  return {
    billable_unit: 1,
    billable_unit_text: one ? one.value : "1 unit - 8-22 minutes"
  };
};

/**
 * @param {number|null|undefined} durationMinutes
 * @param {boolean} applySingleUnitOverride - true only when a CPT is selected and its flag is true
 */
export function resolveBillableUnitFromDurationAndCptFlag(
  durationMinutes,
  applySingleUnitOverride
) {
  if (applySingleUnitOverride === true) {
    return singleUnitTier();
  }
  let billable_unit = 0;
  let billable_unit_text = BILL_UNIT_TIERS[0].value;
  if (
    typeof durationMinutes === "number" &&
    !Number.isNaN(durationMinutes) &&
    durationMinutes > 0
  ) {
    for (const unit of BILL_UNIT_TIERS) {
      if (
        unit.start_time <= durationMinutes &&
        unit.end_time >= durationMinutes
      ) {
        billable_unit = unit.key;
        billable_unit_text = unit.value;
        break;
      }
    }
  }
  return { billable_unit, billable_unit_text };
}

/**
 * Billable unit for visit-bills add/edit. Single-unit rule runs only if a CPT id is selected
 * and that CPT's is_single_billable_unit === true.
 */
export function getBillableUnitForVisitPayload({
  visitMarkedNotBillable,
  selectedCptId,
  hasStartAndEnd,
  durationMinutes,
  isSingleBillableUnitFromSelectedCpt
}) {
  if (visitMarkedNotBillable) {
    return 0;
  }
  const applySingle =
    !!selectedCptId &&
    hasStartAndEnd === true &&
    isSingleBillableUnitFromSelectedCpt === true;
  const { billable_unit } = resolveBillableUnitFromDurationAndCptFlag(
    hasStartAndEnd ? durationMinutes : null,
    applySingle
  );
  return billable_unit;
}
